import {Component, OnInit} from '@angular/core';
import {Profile} from '../update-my-profile/models/profile.model';
import {UpdateProfileService} from '../update-my-profile/services/update-my-profile.service';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {AppConstants} from "../utils/constants";

@Component({
    selector: 'app-contact-person',
    templateUrl: './contact-person.component.html',
    styleUrls: ['./contact-person.component.scss'],
    standalone: false
})
export class ContactPersonComponent implements OnInit {

  private loggedInUserProfile: Profile = new Profile();
  private contactPersonForm: UntypedFormGroup;
  private homePath = AppConstants.homePage;
  private loading = false;

  constructor(private _updateProfileService: UpdateProfileService,
              private _formBuilder: UntypedFormBuilder,) {
    this.contactPersonForm = this._formBuilder.group({
      firstName: [
        {
          value: '',
          disabled: true
        }
      ],
      lastName: [
        {
          value: '',
          disabled: true
        }
      ],
      phone: [
        {
          value: '',
          disabled: true
        }
      ],
      email: [
        {
          value: '',
          disabled: true
        }
      ],
      title: [
        {
          value: '',
          disabled: true
        }
      ]
    });
  }

  public getContactPersonForm() {
    return this.contactPersonForm;
  }

  public getHomePath() {
    return this.homePath;
  }

  public getLoading() {
    return this.loading;
  }


  ngOnInit() {
    this._updateProfileService.fetchProfile()
      .subscribe(res => {
        this.loggedInUserProfile = res;
        if (res.contactPerson) {
          this.contactPersonForm.controls.firstName.setValue(res.contactPerson.firstName);
          this.contactPersonForm.controls.lastName.setValue(res.contactPerson.lastName);
          this.contactPersonForm.controls.phone.setValue(res.contactPerson.phone);
          this.contactPersonForm.controls.email.setValue(res.contactPerson.email);
          this.contactPersonForm.controls.title.setValue(res.contactPerson.title);
        }
      });
  }

}
